import React from "react";
import { Button } from "@fluentui/react-components";
import { useStyles } from "./styles/PaginationControls.style";
import { ChevronLeft16Regular, ChevronRight16Regular } from "@fluentui/react-icons";

interface PaginationControlsProps {
    page: number;
    pageSize: number;
    totalResults: number;
    setPage: (page: number) => void;
}

export const PaginationControls: React.FunctionComponent<PaginationControlsProps> = ({
    page,
    pageSize,
    totalResults,
    setPage,
}) => {
    const styles = useStyles();

    if (totalResults === 0) {
        return null; 
    }

    const totalPages = Math.ceil(totalResults / pageSize);

    return (
        <div className={styles.paginationControls}>
            <Button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className={styles.leftPaginationButton}
                iconPosition="before"
                icon={<ChevronLeft16Regular />}
            >
                Previous
            </Button>
            <div className={styles.pageInfo}>
                Page {page} of {totalPages}
            </div>
            <Button
                disabled={page >= totalPages}
                onClick={() => setPage(page + 1)}
                className={styles.rightPaginationButton}
                iconPosition="after"
                icon={<ChevronRight16Regular />}
            >
                Next
            </Button>
        </div>
    );
};
